module.exports = __webpack_public_path__ + "static/media/downloadCenterMenu.0a1507b6.svg";